<template>
    <div>
        <div class="income-container">
            <el-form :inline="true" size="small">
                <el-row>
                    <el-col :span="5">
                        <el-form-item label="账户名称">
                            <el-input v-model="query.name" style="width: 100%;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="创建日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="query.startDate"
                                style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="状态">
                            <el-select clearable v-model="query.status" placeholder="请选择状态" style="width: 100%;">
                                <el-option label="等待审核" :value="0"></el-option>
                                <el-option label="审核通过" :value="1"></el-option>
                                <el-option label="审核失败" :value="-1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="关键字">
                            <el-input v-model="query.key" style="width: 100%;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" size="small" @click="onQueryextransactionrecord(1,10)">查询</el-button>
                        <el-button type="primary" size="small" plain>重置</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div>
                <div class="status-container">
                    <div class="status-item" :class="{ 'active': activeStatus === 'pending' }"
                        @click="setActiveStatus('pending')">
                        待审批（100）
                    </div>
                    <div class="status-item" :class="{ 'active': activeStatus === 'approved' }"
                        @click="setActiveStatus('approved')">
                        审批通过（22）
                    </div>
                    <div class="status-item" :class="{ 'active': activeStatus === 'unreceived' }"
                        @click="setActiveStatus('unreceived')">
                        未收到（5）
                    </div>
                    <div class="add-button-container">
                        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDialog">添加</el-button>
                    </div>
                </div>
                <el-table :data="tableData" style="width: 100%" border max-height="500">
                    <el-table-column prop="" label="账户名称" width="120">
                    </el-table-column>
                    <el-table-column label="类型" width="120">
                        <template slot-scope="scope">
                            <span>支出</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" width="120">
                    </el-table-column>
                    <el-table-column prop="operator" label="操作人" width="120">
                    </el-table-column>
                    <el-table-column prop="createdTime" label="创建日期" width="180">
                    </el-table-column>
                    <el-table-column prop="status" label="审批状态" width="120">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 1" style="color: #67C23A;">审核通过</span>
                            <span v-else-if="scope.row.status == -1" style="color: #F56C6C;">审核失败</span>
                            <span v-else-if="scope.row.status == 0" style="color: #E6A23C;">等待审核</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="支付用途" width="200">
                    </el-table-column>
                    <el-table-column prop="screenshot" label="截图" width="120">
                        <template slot-scope="scope">
                            <img v-if="scope.row.imageUrl" :src="scope.row.imageUrl" alt="截图" style="max-width: 80px;">
                            <div v-else>无截图</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small">确认支出</el-button>
                            <el-button type="text" size="small" style="color: #F56C6C;">取消支出</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-pagination">
                    <el-pagination @current-change="currentChange" :current-page="query.page" :page-size="10"
                        layout="total, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 添加对话框 -->
        <el-dialog title="添加支出" :visible.sync="addDialogVisible" width="500px">
            <el-form :model="addForm" label-width="100px">
                <el-form-item label="支付金额">
                    <el-input v-model="form.amount" placeholder="请输入支付金额"></el-input>
                </el-form-item>
                <el-form-item label="支付账户">
                    <el-select filterable clearable v-model="form.accountId" placeholder="请选择支付账户" style="width: 100%;">
                        <el-option v-for="item in accountList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="支付用途">
                    <el-input v-model="form.remark" type="textarea" placeholder="请输入支付用途" :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="相关图片">
                    <upload v-model="form.imageUrl" accept="img" :auto-upload="true" :image-url="form.imageUrl"
                        :drag="'drag'" thisType="custom" @input="toImg($event, 'imageUrl')"
                        :customSty="{ width: '360px', height: '154px' }">
                    </upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveAddForm">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { queryextransactionrecord, addextransactionrecord ,getQueryaccount,accountlist} from '@/api/finance';
import upload from '@/components/upload.vue';
export default {
    data() {
        return {
            form: {
                amount: 0,
                accountId: "",
                remark: "",
                imageUrl: "",
                AccountInfo:"test"
            },
            activeStatus: 'pending',
            addDialogVisible: false,
            accountList: [],
            addForm: {
                amount: '',
                account: '',
                purpose: ''
            },
            tableData: [],
            total: 0,
            query: {
                page: 1,
                pageSize: 10,
                key: '',
                status: '',
                startDate: '',
            }
        }
    },
    methods: {
        toImg(e, type) {
            this.form[type] = e
        },
        setActiveStatus(status) {
            this.activeStatus = status;
        },
        openAddDialog() {
            this.addDialogVisible = true;
        },
        saveAddForm() {
            // 保存逻辑
            addextransactionrecord(this.form).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.addDialogVisible = false;
                    this.query.page = 1;
                    this.onQueryextransactionrecord();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            })
            // 关闭对话框
            
        },
        currentChange(value) { 
            this.query.page = value;
            this.onQueryextransactionrecord();
        },
        onQueryextransactionrecord(page,pageSize) {
            queryextransactionrecord({
                "Key": this.query.key,
                "Status": this.query.status,
                "StartDate": this.query.startDate,
                "Page.Index": page ? page : this.query.page,
                "Page.Size": pageSize ? pageSize : this.query.pageSize,
            }).then(res => {
                this.tableData = res.data.rows;
                this.total = res.data.total;
            })
        }
    },
    created() {
        accountlist().then(res => {
            this.accountList = res.data.map(t => {
                return {
                    label: t.accountName,
                    value: t.id,
                }
            });
        })
        this.onQueryextransactionrecord();
    }
}
</script>
<style scoped lang="scss">
.income-container {}

::v-deep .el-form--inline .el-form-item {
    display: flex;
    align-items: center;

    .el-form-item__label {
        width: 70px;
    }

    .el-form-item__content {
        width: calc(100% - 70px);
    }

}

.status-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .status-item {
        padding: 4px 12px;
        margin-right: 8px;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: 12px;
        border: 1px solid #dcdfe6;

        &:hover {
            background-color: #ecf5ff;
            border-color: #c6e2ff;
        }

        &.active {
            background-color: #409EFF;
            color: white;
            border-color: #409EFF;
            box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
        }
    }

    .add-button-container {
        margin-left: auto;
    }
}

.snapshot-upload {
    width: 100%;
    height: 100px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f7fa;
}

.table-pagination {
    margin-top: 15px;
    text-align: right;
}
</style>
